<template lang="pug">
	div.step-content.state-select(v-if="ready" v-observe-visibility="{callback: setCurrentStep, intersection:{threshold:0.8}}")
		h2.mb-5(v-if="memberExperiencePage") What is your state of residence?
		sfc-select-wrapper(:errorMessage="''" :error="false" :flat="false")
			select(v-model="stateOfResidence" @change="setState()")
				option(value="-" disabled hidden) Select your state
				option(v-for="state of states" :key="state.id" v-bind:value="state") {{state.name}}
		div.complete-onboarding-btn(v-if="memberExperiencePage")
				button.btn.sfc-blue(@click="setSavingUser()")
					| OK
					span.arrow-right
		a.btn.sfc-blue(@click="goToNextScreen()" :loading="loading" v-else) SHOW ME

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	a.btn
		padding: 10px 40px
	.complete-onboarding-btn
		.btn
			position: relative
			display: inline-block
			margin-left: 0px
			padding-right: 30px
			span.arrow-right
				border-left-color: #fff
			&:hover
				+ .press-enter
					color: sfc-blue-link
	.state-select
		>>> select
			@media(max-width: 767px)
				font-size: body-font-size-md !important

		@media(max-width: 575px)
			text-align: center
			>>> .dd
				label
					margin: auto
</style>

<script>
	import InputBtnWrapper from '@/common/components/inputs/btn-wrapper'

	export default {

		layout: 'default',

		components: {
			InputBtnWrapper
		},

		data(){
			let currentState = "-"
			return {
				ready: true,
				stateOfResidence: currentState,
				states: this.$store.state.states,
				error: false,
				errorMessage: "Please choose your state",
				loading: false,
				memberExperiencePage: false
			}
		},

		async mounted(){

			if (this.$route.name == "savings-center"){
				this.memberExperiencePage = true
			}

			try{
				if(process.browser){
					const query = `
						query{
							no_graphql_cache()
							state_from_ip(click_source:"best_plans"){
								id
								sfc_id
								name
								slug
							}
						}
					`
					const response = await this.$httpService.graphql(query)
					let responseState = response.data.state_from_ip

					for(let state of this.states){
						if(state.string_id == responseState.id){
							this.stateOfResidence = state
							this.$cookies.set('collegeSavingsUserOnboardingState', this.stateOfResidence, {
								path: '/',
								domain: 'savingforcollege.com',
								maxAge: 365 * 24 * 60 * 60
							})
							if(this.memberExperiencePage){
								this.setSavingUser()
							}
							break
						}
					}
				}
			} catch {

			}

			this.setState()
		},

		methods:{
			setCurrentStep(isVisible, entry){
				return
				if(isVisible){
					this.$parent.setCurrentStep('state-of-residence-question')
				}
			},

			setState(){
				this.$cookies.set('collegeSavingsUserOnboardingState', this.stateOfResidence, {
					path: '/',
					domain: 'savingforcollege.com',
					maxAge: 365 * 24 * 60 * 60
				})
			},

			async setSavingUser(){
				this.loading = true
				const query = `
					mutation{
						college_savings_user_v2(sfc_token: "${this.$cookies.get('sfc_primary')}", token:"${this.$cookies.get('college_savings_token')}", state_id:"${this.stateOfResidence.string_id}"){
							children{
								name
							}
						}
					}
				`
				const response = await this.$httpService.graphql(query)
				const savingsUser = response.data.college_savings_user_v2
				if(!savingsUser || savingsUser.children.length == 0){
					this.$parent.goToNextQuestion("state-of-residence-question")
				}else{
					window.location.href = '/savings-center/recommendations'
				}
				return
			},

			async goToNextScreen(){
				this.loading = true
				this.setState()
				const query = `
					mutation{
						college_savings_user_v2(sfc_token: "${this.$cookies.get('sfc_primary')}", token:"${this.$cookies.get('college_savings_token')}", state_id:"${this.stateOfResidence.string_id}"){
							children{
								name
							}
						}
					}
				`
				const response = await this.$httpService.graphql(query)
				const savingsUser = response.data.college_savings_user_v2



				if(!savingsUser){
					window.location.href = "/savings-center"
					return
				}

				if(savingsUser.children.length == 0){
					window.location.href = "/savings-center"
					return
				}
				window.location.href = '/savings-center/recommendations'
				return
			}
		},

	}
</script>
